import { useTranslation } from "react-i18next";

export type Period = "all" | "today" | "week" | "month";

export const PERIODS: Period[] = ["all", "today", "week", "month"];

export const periodSince = (p: Period): Date | null => {
  if (p === "all") return null;
  const d = new Date();
  if (p === "today") d.setDate(d.getDate() - 1);
  else if (p === "week") d.setDate(d.getDate() - 7);
  else if (p === "month") d.setDate(d.getDate() - 30);
  return d;
};

type Props = {
  value: Period;
  onChange: (v: Period) => void;
};

export const DateFilterPills = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-nowrap gap-2 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {PERIODS.map((p) => {
        const active = value === p;
        return (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-pressed={active}
            className={`inline-flex shrink-0 items-center rounded-full border px-4 py-1.5 text-sm font-bold transition ${
              active
                ? "border-primary bg-primary text-primary-foreground shadow"
                : "border-border bg-card text-foreground hover:border-primary"
            }`}
          >
            {t(`filter.period.${p}`)}
          </button>
        );
      })}
    </div>
  );
};

export default DateFilterPills;
